var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScreenRotation = function SvgScreenRotation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#screen-rotation_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 4h8v16H8zM6 4c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2zm14.1 14.57a.996.996 0 0 0 .47 1.33l-.01.01c.49.24 1.09.03 1.33-.47 1.34-2.79 2.09-5.08 2.1-7.43.009-1.943-.485-3.838-1.43-6.01H23c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.507 0-.93.383-.992.874-.025.19.003.39.093.576C21.43 8.13 22 10.09 22 12c-.01 1.91-.61 3.88-1.9 6.57M3.43 4.1c.5.24.71.84.47 1.33C2.61 8.12 2.01 10.09 2 12c0 1.91.57 3.87 1.9 6.55.105.218.126.454.075.67-.1.445-.5.78-.975.78H1c-.55 0-1-.45-1-1s.45-1 1-1h.435C.485 15.829-.008 13.935 0 12c.01-2.35.76-4.64 2.1-7.43.24-.5.84-.71 1.33-.47M13 18.23a1 1 0 1 1-2 0 1 1 0 0 1 2 0",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "screen-rotation_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgScreenRotation;